import { Button, Divider, Form, Input, message, Space, Spin, Typography } from "antd";
import React, { useState } from "react";
import { apiCall } from "../utils/Api";

export default function ListAddReplace(props) {

    const { close = () => { }, list_id = "", onComplete = () => {} } = props;

    const [loading, setLoading] = useState(false);


    const uploadFile = (_file) => {
        setLoading(true);
        apiCall("titlelist/importFile", { file: _file.file, list_id: list_id, add_to_list: false, only_unique: true }, (_status, _result) => {
            if (_status) {
                let list = _result.result.titles.map(item => { return item.isbn });
                onComplete(list);
                close(); 
            } else {
                message.error(_result.error)
            }
            setLoading(false);
        }, "customer");
    }

    const generateFile = (_text) => {
        var filename = 'pasted.txt';
        let _file = new File([new Blob([_text])], filename)
        let f = {}
        f.file = _file;
        uploadFile(f);
    }


    const save = (_f) => {
        generateFile(_f["isbns"])
    }


    return (
        <div style={{ "padding": "20px" }}>
            <Spin spinning={loading}>
                <Typography.Title level={5}>Replace all</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />
                <Typography.Paragraph >Type or paste ISBNs below and click "Save" to replace the existing ISBNs with the new ones you provide.
                    <div className="shim" /><div className="shim" />
                    <small><span style={{ color: 'red' }}>*</span> Any ISBNs not found in our system will be omitted.</small>
                </Typography.Paragraph>
                <Form onFinish={(_f) => save(_f)} layout="vertical">
                    <Form.Item noStyle name="isbns">
                        <Input.TextArea placeholder="ISBNs..." rows={10}></Input.TextArea>
                    </Form.Item>
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <Space>
                            <Button onClick={() => close()}>Cancel</Button>
                            <Button loading={loading} htmlType="submit" type="primary">Save</Button>
                        </Space>
                    </div>
                </Form>
            </Spin>
        </div>
    )







    // <Input.TextArea style={{ "fontFamily": "ApercuMono" }} onFocus={() => setCanSave(false)} onBlur={(e) => generateFile(e.target.value)} placeholder={placeholder} defaultValue={drawText(processed)} rows={13} />


    // /tbm_site/titlelist/replaceIsbns

    // list_id

    // isbns_json


}